import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktBaseCommand } from "./ArbetsorderProduktBaseCommand";

export class DeleteArbetsorderProduktCommand extends ArbetsorderProduktBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteArbetsorderProduktCommand";

    constructor(handelssortimentId: number, produktId: number, arbetsorderId: number) {
        super(DeleteArbetsorderProduktCommand.$type, CommandType.Delete);
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.arbetsorderId = arbetsorderId;
    }
}
